export default {
    root: {
        paddingBottom: '8px',
      },
}